"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _urlSearchParams = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url-search-params"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _FilterSegment = _interopRequireDefault(require("./FilterSegment"));
var _constants = require("../../../constants");
var _AuAnalytics = _interopRequireDefault(require("../../../utils/AuAnalytics"));
var _Filter = require("./Filter");
var _AutoIntl = _interopRequireDefault(require("../AutoIntl"));
var _context3, _context4, _context8, _context9;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "sidebar_filters-module__container___SJMoG",
  "header": "sidebar_filters-module__header___FgjN3",
  "label": "sidebar_filters-module__label___uxfEa",
  "reset": "sidebar_filters-module__reset___xnUw2",
  "close": "sidebar_filters-module__close___URyzy",
  "content": "sidebar_filters-module__content___n6tas",
  "visible": "sidebar_filters-module__visible___p3JB2",
  "filter_header": "sidebar_filters-module__filter_header___b0UE3"
};
class SidebarFilters extends _react.default.Component {
  static propTypes = {
    filtersDef: T.array.isRequired,
    knownFilters: T.object.isRequired,
    browserHistory: T.object.isRequired,
    actions: T.shape({
      saveUserData: T.func
    }).isRequired,
    className: T.string,
    showCloseBtn: T.bool,
    onInit: T.func,
    onClose: T.func,
    onChange: T.func,
    registerResetHandler: T.func,
    shouldHideContent: T.func,
    queryParams: T.object,
    queryParamsPath: T.object
  };
  static defaultProps = {
    showCloseBtn: true,
    onInit: _constants.NOOP,
    onToggle: _constants.NOOP,
    onChange: _constants.NOOP,
    registerResetHandler: _constants.NOOP
  };
  defaultFilters = {};
  _contentRef = /*#__PURE__*/_react.default.createRef();

  // stores filter promises
  _initializedFilters = [];

  // stores filter promise resolvers
  filterResolvers = {};
  constructor(props) {
    super(props);
    const {
      filtersDef
    } = props;
    this.state = {
      idx: 0,
      filters: {},
      ready: false,
      showResetBtn: false
    };
    this.defaultFilters = (0, _reduce.default)(filtersDef).call(filtersDef, (acc, filter) => {
      const {
        name,
        defaultValue
      } = (0, _values.default)(filter)[0];
      if (defaultValue && !this.shouldSkipFilter(filter)) {
        acc[name] = (0, _Filter.convertToFilters)({
          urlValue: defaultValue
        }, name);
      }
      return acc;
    }, {});
  }
  componentDidMount() {
    const {
      filtersDef,
      queryParams,
      registerResetHandler,
      browserHistory
    } = this.props;
    registerResetHandler(this.handleFiltersReset);
    if (queryParams) {
      // restore previously applied query params
      browserHistory.replace({
        search: queryParams
      });
    }

    // add search params to filters
    const filters = (0, _reduce.default)(filtersDef).call(filtersDef, (acc, filter) => {
      const {
        name,
        properties
      } = (0, _values.default)(filter)[0];
      if (this.shouldSkipFilter(filter)) {
        return acc;
      }
      const windowParams = new _urlSearchParams.default(window.location.search);
      acc[name] = this.createFiltersFromWindowParams(windowParams, name, name);
      if (properties) {
        var _context;
        (0, _forEach.default)(_context = (0, _values.default)(properties)).call(_context, property => {
          acc[name].push(...this.createFiltersFromWindowParams(windowParams, property, name));
        });
      }
      this._initializedFilters.push(new _promise.default(resolve => {
        this.filterResolvers[name] = resolve;
      }));
      return acc;
    }, {});

    // notify when all the filters got initialized
    _promise.default.all(this._initializedFilters).then(() => this.props.onInit(this.state.filters, this.filtersCount));
    this.setState({
      filters,
      ready: true
    });
  }
  createFiltersFromWindowParams(windowParams, paramKey, filterName) {
    const filters = [];
    const params = windowParams.getAll(paramKey);
    (0, _forEach.default)(params).call(params, param => {
      const decodedParam = decodeURIComponent(param);
      filters.push((0, _Filter.convertToFilters)({
        urlKey: paramKey,
        urlValue: decodedParam
      }, filterName)[0]);
    });
    return filters;
  }
  componentWillUnmount() {
    const {
      queryParamsPath,
      actions
    } = this.props;
    const {
      search
    } = this.state;
    // save query params
    actions.saveUserData(search, ['query', queryParamsPath]);
  }
  get filtersCount() {
    var _context2;
    return (0, _reduce.default)(_context2 = (0, _values.default)(this.state.filters)).call(_context2, (acc, filterArr) => {
      return acc + (0, _filter.default)(filterArr).call(filterArr, item => item.shouldDisplayBubble).length;
    }, 0);
  }
  shouldSkipFilter(filter) {
    const filterDef = (0, _values.default)(filter)[0];
    return this.props.shouldHideContent ? this.props.shouldHideContent(filterDef) : false;
  }
  handleFilterInit = (0, _bind.default)(_context3 = this.handleFilterInit).call(_context3, this);
  handleFilterInit(filterName, selectedItems) {
    this.handleFilterChange(filterName, selectedItems, false);
    if (this.filterResolvers[filterName]) {
      this.filterResolvers[filterName]();
    }
  }
  handleFilterChange = (0, _bind.default)(_context4 = this.handleFilterChange).call(_context4, this);
  handleFilterChange(filterName, selectedItems, commitChanges = true) {
    this.setState(prevState => {
      var _context5;
      // update filters and search params
      const updatedFilters = (0, _Filter.convertToFilters)(selectedItems, filterName);
      const filters = {
        ...prevState.filters,
        [filterName]: updatedFilters
      };
      const searchParams = new _urlSearchParams.default();
      (0, _forEach.default)(_context5 = (0, _values.default)(filters)).call(_context5, filterArr => {
        (0, _forEach.default)(filterArr).call(filterArr, filter => {
          if (filter.shouldUseInUrl) {
            searchParams.append(filter.urlKey, filter.urlValue);
          }
        });
      });

      // hide the Reset button when `sidebarFilters` match `defaultFilters`
      const showResetBtn = this.areFiltersDefault(filters);
      const search = searchParams.toString();
      this.props.browserHistory.replace({
        search
      });
      return {
        filters,
        showResetBtn,
        search
      };
    }, commitChanges ? this.commitChanges : _constants.NOOP);
  }
  areFiltersDefault(filters) {
    var _context6;
    return (0, _some.default)(_context6 = (0, _keys.default)(filters)).call(_context6, filterKey => {
      const defaultFilter = this.defaultFilters[filterKey];
      if (defaultFilter && defaultFilter.length > 0) {
        var _context7;
        return (0, _some.default)(_context7 = filters[filterKey]).call(_context7, filter => {
          return filter.shouldUseInUrl && filter.urlValue !== defaultFilter[0].urlValue;
        });
      }
      return filters[filterKey].length !== 0;
    });
  }
  handleFiltersReset = (0, _bind.default)(_context8 = this.handleFiltersReset).call(_context8, this);
  handleFiltersReset() {
    _AuAnalytics.default.trackEvent({
      category: 'SidebarFilters',
      action: 'Reset: AllFilters'
    });
    this.setState(prevState => ({
      filters: {
        ...this.defaultFilters
      },
      showResetBtn: false,
      idx: prevState.idx + 1 // force re-render
    }), this.commitChanges);
  }
  commitChanges = (0, _bind.default)(_context9 = (0, _debounce.default)(this.commitChanges, 100)).call(_context9, this);
  commitChanges() {
    this.props.onChange(this.state.filters, this.filtersCount);
  }
  renderFilterSegments() {
    const {
      filtersDef,
      knownFilters
    } = this.props;
    const {
      filters
    } = this.state;
    return (0, _map.default)(filtersDef).call(filtersDef, filter => {
      let [componentName, filterDef] = (0, _entries.default)(filter)[0];
      let Filter = knownFilters[componentName];
      if (!Filter || this.shouldSkipFilter(filter)) {
        return false;
      }
      const selection = filters[filterDef.name] || [];
      return /*#__PURE__*/_react.default.createElement(_FilterSegment.default, (0, _extends2.default)({}, filterDef, {
        key: `filter_segment-${filterDef.name}`,
        Filter: Filter,
        selection: selection,
        customProperties: filterDef.properties,
        contentRef: this._contentRef,
        className: styles.segment,
        onFilterInit: this.handleFilterInit,
        onFilterChange: this.handleFilterChange,
        visibleClassName: styles.visible,
        expandedClassName: styles.expanded,
        headerClassName: styles.filter_header,
        filterClassName: styles.filter_content
      }));
    });
  }
  render() {
    const {
      className,
      showCloseBtn,
      onClose
    } = this.props;
    const {
      idx,
      ready,
      showResetBtn
    } = this.state;
    if (!ready) {
      return false;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.header
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      "data-count": this.filtersCount,
      className: styles.label,
      displayId: "au.sidebarFilters.filters"
    }), showResetBtn && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "au.sidebarFilters.reset",
      className: styles.reset,
      onClick: this.handleFiltersReset,
      tag: "a"
    }), showCloseBtn && /*#__PURE__*/_react.default.createElement("a", {
      className: styles.close,
      onClick: onClose
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.content,
      ref: this._contentRef,
      key: `filters_${idx}`
    }, this.renderFilterSegments()));
  }
}
exports.default = SidebarFilters;